import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk'
import rootReducer from './stores'
import LoopFront from 'loop-front';
import Config from './Resources/Config';
import { composeWithDevTools } from 'redux-devtools-extension';

const rxStore = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(thunk))
)

LoopFront.init(Config.API_BASE_URL);

ReactDOM.render(
    <Provider store={rxStore} >
        <App />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
